import React, {Component, Fragment} from 'react';
import {Redirect} from 'react-router-dom';
import {connect} from "react-redux";
import './index.scss';
import {
    addPopup,
    removePopup,
    getBenefitById,
    setBenefitPage,
    addItem,
    addToken,
} from "../../redux/actions";
import { AnalyticsParamValues } from '../../constants/analytics';
import * as Popups from '../../constants/popup-types';
import * as routes from '../../constants/routes';
import AnalyticsManager from '../../app/analytics';
import {
    reactParserCommonOptions,
    convertToSortedArray,
    formatNumber,
    getMediaPath,
    createAnalyticsItemsList, cleanUpObject,
} from '../../app/functions';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactHtmlParser from 'react-html-parser';

//components
import Timer from "../shared/timer/timer";
import Collapse from "../../components/common/collapse";
import BenefitsSlider from '../../containers/shared/benefits-slider/benefits-slider';
import BreadCrumbs from '../../components/common/bread_crumbs';

import FavoriteButton from '../shared/favorite-btn';
import Loader from "../../components/common/loader";
import Select from "../../components/forms/select";


//assets
import plus from 'assets/icons/arrow_down.svg';
import arrow_gallery from 'assets/icons/arrow-gallery.svg';
import warranty from 'assets/icons/warrenty.svg';
import truck from 'assets/icons/truck.svg';
import arrow from 'assets/icons/slider-arrow-blue.svg';
import radio_empty from 'assets/icons/radio-empty.svg'
import radio_checked from 'assets/icons/radio-checked.svg'
import fire from 'assets/icons/fire.svg';
import benefitsLock from 'assets/icons/benefits-lock.svg';
import ImageCarousel from "../../components/image-carousel";


class CommercePage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            big_screen_url: false,
            big_screen_type: false,
            selected_img: 0,
            selected_collapse: -1,
            input: {val: 0, first_try: true},
            preview_link: false,

            drops: null,
            selected_radio: null,

            price: null,
            old_price: null,
            cda: null,
            cashback_description: "",

            selected_nav_tab: 0,

            first_try: true,
        };

        this.getExtraData = this.getExtraData.bind(this);
        this.handleCollapseOnClick = this.handleCollapseOnClick.bind(this);

        this.submitClick = false;
    }

    componentDidMount() {
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        if (urlParams.has('preview_link')) {
            var preview = urlParams.get('preview_link');
            this.props.getBenefitById({benefitId: this.props.match.params.id, preview_link: preview, isCommerce: 1});
            this.setState({preview_link: true});
        } else {
            this.props.getBenefitById({benefitId: this.props.match.params.id, isCommerce: 1});
        }
// this.isCashBack();

        document.body.classList.add('benefitPageBody');
    }

    componentWillUnmount() {
        this.props.setBenefitPage(false);
        document.body.classList.remove('benefitPageBody');
    }

    componentDidUpdate(nextProps) {
        if (this.props.match.params.id !== nextProps.match.params.id) {
            this.props.getBenefitById({benefitId: this.props.match.params.id, isCommerce: 1});
        }
        if (this.props.benefit !== nextProps.benefit && this.props.benefit) {
            const type = this.props.benefit.optionsArr.optionsType;
            if (this.props.benefit && this.props.benefit !== 'error') {
                AnalyticsManager.logViewItem(createAnalyticsItemsList([{
                    ...this.props.benefit,
                    selectedOption: this.state.selected_radio,
                }]));

                const data = this.props.benefit.optionsArr.options;
                const option_id = this.props.match.params.option_id;

                if (type === 'drops') {
                    let drops = {};

                    const selected = this.searchTree(data[Object.keys(data)[0]], option_id);

                    const price = selected.price;
                    const cda = selected.cda;
                    const old_price = selected.old_price;
                    const levels = data.levels;

                    for (let i = 0; i < levels; i++) {
                        drops[i] = -1;
                    }
                    const updatedPrice = this.isCashBack() ? data.cashback_price : price;
                    const cashbackDescription = this.isCashBack() ? data.cashback_description : "";
                    this.setState({
                        drops: drops,
                        price: updatedPrice,
                        // price: data.cheapest_price,
                        cda: cda,
                        old_price: old_price,
                        cashback_description: cashbackDescription,
                    });
                } else if (type === 'radio') {
                    let first = this.props.benefit.optionsArr.options[option_id];
                    if (first !== undefined) {
                        const updatedPrice = this.isCashBack() ? first.cashback_price : first.price;
                        const cashbackDescription = this.isCashBack() ? first.cashback_description : "";

                        this.setState({
                            selected_radio: first.id,
                            price: updatedPrice,
                            old_price: first.old_price,
                            cda: first.cda,
                            cashback_description: cashbackDescription,
                        });
                    }
                } else {
                    this.setState({
                        price: this.props.benefit.main.price_after_discount,
                        old_price: this.props.benefit.main.price_before_discount,
                    });
                }
            }
            if (this.props.benefit === 'error') {
                this.props.history.push(routes.home);
            }
        }

        if (this.props.cart !== nextProps.cart) {
            this.props.history.push(routes.payment);
        }
    }

    searchTree = (drops_tree, option_id) => {
        let res = null;

        for (let key in drops_tree.itemsArr) {
            if (drops_tree.itemsArr[key]?.cda == option_id)
                res = drops_tree.itemsArr[key];

            else if ('next' in drops_tree.itemsArr[key]) {
                res = this.searchTree(drops_tree.itemsArr[key].next[Object.keys(drops_tree.itemsArr[key].next)[0]], option_id);

                if (res !== null) {
                    return res;
                }
            }
        }
        return res;
    };

    checkDropsValidation = () => {
        const drops = this.state.drops;
        let valid = true;

        for (let key in drops) {
            if (drops[key] === -1)
                valid = false;
        }

        return valid;
    };

    handleCollapseOnClick(id) {
        if (id === this.state.selected_collapse)
            id = -1;
        this.setState({selected_collapse: id})
    }

    getExtraData() {

        const isLaptopOrDesktop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';

        const data = this.props.benefit.information;

        let res = [];

        if (isLaptopOrDesktop) {

            if (data.length > 0) {
                res.push(
                    <div key={'y10010101'} className='navbar'>
                        {this.props.benefit.information.map((item, index) => {
                            return <span key={index}
                                         className={'nav-op ' + (this.state.selected_nav_tab === index ? 'selected' : '')}
                                         onClick={() => {
                                             this.setState({selected_nav_tab: index})
                                         }}>{item.title}</span>
                        })}
                    </div>
                );

                res.push(
                    <div key={'z10010101'} className='details-wrapper'>
                        <div className='content'>
                            {ReactHtmlParser(data[this.state.selected_nav_tab].content, reactParserCommonOptions())}
                        </div>
                    </div>
                );
            }
        } else {
            data.forEach((item, index) => {
                res.push(
                    <Collapse key={index}
                              id={index}
                              className={'details-collapse'}
                              label={item.title}
                              custom_arrow={getMediaPath(plus)}
                              handleCollapseState={this.handleCollapseOnClick}
                              open={this.state.selected_collapse === index}>
                        {ReactHtmlParser(item.content, reactParserCommonOptions())}
                    </Collapse>
                )
            });
        }

        return res;
    }

    handleFavClick = () => {
        this.setState({is_loved: !this.state.is_loved});
    };

    handleAddAddress = (cards, errMsg, btnText) => {
        if (cards.length > 0) {
            this.props.addItem({
                benefitId: this.props.match.params.id,
                cda: this.state.cda,
                amount: 1,
            });
        } else {
            errMsg = this.props.text['commerce_cards_err'];
            this.props.addPopup({
                type: Popups.ADD_CREDIT_CARD_POPUP,
                text: errMsg,
                btnText: btnText,
                benefitId: this.props.match.params.id,
                cda: this.state.cda,
            });
        }
    }

    handleBuyClick = () => {
        const { benefit } = this.props;

        const benefitId = benefit.main.id;
        const benefitTitle = benefit.main.title;

        //check if user logged in
        if (!this.submitClick) {
            this.submitClick = true;
            if (this.props.userData) {
                AnalyticsManager.logAddToCart(createAnalyticsItemsList([{
                    ...benefit,
                    selectedOption: this.state.selected_radio,
                }]), benefit?.optionsArr?.options?.[this.state.selected_radio]?.price);
                AnalyticsManager.logProductBuyWithClickPress(benefitId, benefitTitle);

                const cards = this.props.userData.cardsArr.filter(card => {
                    return card.active === true;
                });
                const address = this.props.userData.addressArr.filter(item => {
                    return item.active === true;
                });
                let errMsg = '';
                let action = null;
                const btnText = 'מעבר לאיזור אישי';

                if (cards.length === 0 || address.length === 0) {
                    if (address.length === 0) {
                        errMsg = this.props.text['commerce_address_err'];
                        this.props.addPopup({
                            type: Popups.ADD_ADDRESS_POPUP,
                            text: errMsg,
                            action: () => this.handleAddAddress(cards, errMsg, btnText),
                            btnText: btnText,
                        });
                    } else {
                        errMsg = this.props.text['commerce_cards_err'];
                        this.props.addPopup({
                            type: Popups.ADD_CREDIT_CARD_POPUP,
                            text: errMsg,
                            btnText: btnText,
                            benefitId: this.props.match.params.id,
                            cda: this.state.cda,
                        });
                    }
                } else if (this.checkDropsValidation()) {
                    this.props.addItem({
                        benefitId: this.props.match.params.id,
                        cda: this.state.cda,
                        amount: 1,
                    });
                } else {
                    this.setState({first_try: false});
                }
            } else {
                this.props.addPopup({
                    type: Popups.LOGIN,
                });
            }

            setTimeout(() => {
                this.submitClick = false;
            }, 2000);
        }
    }

    getButton = () => {
        const { is_data_sharing_consent_required: isDataSharingConsentRequired } = this.props.benefit.main;
        const { consentedToDataSharing = [] } = this.props.userData;

        const isDesktopOrLaptop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';

        const onButtonClick = () => {
            if (isDataSharingConsentRequired && !consentedToDataSharing) {
                this.props.addPopup({
                    type: Popups.DATA_SHARING_POPUP,
                    onAgreement: this.handleBuyClick,
                });
                return;
            }

            this.handleBuyClick();
        };

        if (!isDesktopOrLaptop) {
            return (
                <div className='send-wrapper'>
                    <button className='send-btn' onClick={onButtonClick}>
                        {this.props.text['commerce_buy_btn']}
                    </button>
                </div>
            );
        } else {
            return (
                <div className='send-wrapper'>
                    <button className='send-btn' onClick={onButtonClick}>
                        {this.props.text['commerce_buy_btn']}
                    </button>
                </div>
            );
        }
    };

    handleArrowClick = (current) => {
        const type = this.props.benefit.main.images[current].type;
        const url = type === 'image' ? getMediaPath(this.props.benefit.main.images[current].value) : this.props.benefit.main.images[current].value;
        this.setState({selected_img: current, big_screen_url: url, big_screen_type: type});
    };

    getSliderImages = () => {

        const data = this.props.benefit.main.images;

        let res = [];

        data.forEach((item, index) => {

            let src = getMediaPath(item.value);

            //get youtube thumbnail
            if (item.type === 'embedded') {
                if (item.value.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/)) {
                    let youtube_video_id = item.value.match(/youtube\.com.*(\?v=|\/embed\/)(.{11})/).pop();
                    if (youtube_video_id.length === 11) {
                        src = "//img.youtube.com/vi/" + youtube_video_id + "/0.jpg";
                    }
                }
            }

            let slideToRender = null;

            switch (item.type) {
                case 'embedded': {
                    if (this.props.deviceState === 'mobile') {
                        slideToRender = <iframe src={item.value} title={item.type + '' + index} referrerPolicy="strict-origin-when-cross-origin"/>;
                    } else {
                        slideToRender = <img src={src} alt={this.props.benefit.main.title}/>;
                    }
                    break;
                }
                case 'image':
                    slideToRender = <img src={src} alt={this.props.benefit.main.title}/>;
                    break;
                default:
                    break;
            }

            res.push(
                {
                    src: src,
                    component: slideToRender
                }
            );
        });

        return res;
    };

    getBreadCrumbs = () => {
        const data = this.props.benefit.breadcrumbs;

        let res = [];

        data.forEach(item => {
            const url_name = item.title.replace(/ /g, '_');
            res.push({text: item.title, route: routes.category + '/' + item.id + '/' + url_name});
        });

        return res;
    };

    getSelectionSystem = () => {

        const system = this.props.benefit.optionsArr.optionsType;

        let elementToRender = null;

        switch (system) {
            case "drops":
                elementToRender =
                    <div className='drops-container'>
                        {this.getDropFields()}
                    </div>;
                break;
            case 'radio':
                elementToRender =
                    <div className='radio-group'>
                        {this.getRadioOptions()}
                    </div>;
                break;
            default:
                break;
        }

        return elementToRender;
    };

    getRadioOptions = () => {
        const data = convertToSortedArray(this.props.benefit.optionsArr.options);

        let res = [];

        let count = 0;

        if (data.length > 1) {
            data.forEach(item => {
                const selected = item.id === this.state.selected_radio;

                if (count < 4) {
                    const updatedPrice = this.isCashBack() ? item.cashback_price : item.price;

                    count++;
                    res.push(
                        <div key={count} className={'radio-wrapper ' + (selected ? 'selected' : '')}
                             onClick={() => this.handleRadioOnClick(item)}>
                            <img src={getMediaPath(selected ? radio_checked : radio_empty)} alt={item.title}/>
                            <div className='title-price'>
                                <span className='text'>{item.title}</span>
                                {this.props.userData && <span className='price'>{formatNumber(updatedPrice)}</span>}
                            </div>
                        </div>
                    )
                }
            });


            if (count >= 4) {
                res.push(<span key={count * 10} className='more-options'
                               onClick={this.handleMoreOptionsOnClick}>{this.props.text['commerce_page_radio_more']}</span>)
            }
        }

        return res;
    };

    handleRadioOnClick = (item) => {
        const updatedPrice = this.isCashBack() ? item.cashback_price : item.price;
        const cashbackDescription = this.isCashBack() ? item.cashback_description : "";
        this.setState({
            selected_radio: item.id,
            price: updatedPrice,
            old_price: item.old_price,
            cda: item.cda,
            cashback_description: cashbackDescription
        });
        this.updateUrl(item.id);
    };

    updateUrl = (option_id) => {
        const benefit = this.props.benefit;
        let desc = benefit?.main?.title?.split(' ')?.join('_');
        desc = desc?.split(' - ')?.join('_');
        desc = desc?.split('%')?.join('_');

        this.props.history.push(routes.commerce + '/' + benefit.main.id + '/' + option_id + '/' + desc);
    };

    getDropFields = () => {

        //data structure that keeps the generated drops
        let relevant = [];

        let res = [];

        // pointer => holds the current drop
        let currLevel = this.props.benefit.optionsArr.options;

        //component's state => keeps the chosen answers
        const drops = this.state.drops;

        let i = 0;

        // boolean => show if to show drops options
        let showOptions = true;

        if (drops !== null) {


            while (currLevel !== undefined) {
                currLevel = currLevel[Object.keys(currLevel)[0]];
                if (showOptions) {
                    relevant.push({key: i, title: currLevel.title, options: this.getFieldOptions(currLevel.itemsArr)});
                    // checks if this drops option is selected
                    if (drops[i] !== -1) {
                        currLevel = currLevel.itemsArr[drops[i]].next;
                    } else {
                        //next => pointer for the next drop
                        currLevel = currLevel.itemsArr[Object.keys(currLevel.itemsArr)[0]].next;
                        showOptions = false;
                    }
                    i++;
                } else {
                    relevant.push({key: i++, title: currLevel.title, options: []});
                    currLevel = currLevel.itemsArr[Object.keys(currLevel.itemsArr)[0]].next;
                }
            }

            //prints the drops
            relevant.forEach((item, index) => {
                const disabled = item.options.length < 1;
                const showErr = this.state.drops[index] === -1 && !this.state.first_try;

                item.options.unshift({id: 'title ' + index, text: item.title, title: true});
                res.push(
                    <div key={item.key} className='drop-wrapper'>
                        <Select key={item.key}
                                deviceState='desktop'
                                className='attr-drop'
                                options={item.options}
                                onChange={(id) => this.dropOptionOnSelect(id, item)}
                                placeholder={item.title}
                                arrow={getMediaPath(arrow)}
                                disabled={disabled}
                        />
                        {showErr && <span className='drop-err'>יש לבצע בחירה</span>}
                    </div>
                );
            });
        }

        return res;
    };

    getFieldOptions = (options) => {

        let res = [];

        for (let key in options) {
            const updatedPrice = this.isCashBack() ? options[key].cashback_price : options[key].price;
            const cashbackDescription = this.isCashBack() ? options[key].cashback_description : "";
            res.push({
                id: options[key].id,
                text: options[key].title + (options[key].inventory === 0 ? ' (אזל במלאי)' : ''),
                old_price: options[key].old_price,
                price: updatedPrice, cda: options[key].cda,
                disabled: options[key].inventory === 0,
                cashback_description: cashbackDescription
            });
        }

        return res;
    };

    dropOptionOnSelect = (id, item) => {
        const key = item.key;

        let price = this.state.price;
        let old_price = this.state.old_price;
        let cda = this.state.cda;

        const picked = item.options.filter(curr => {
            return parseInt(curr.id) === parseInt(id);
        });

        if (picked[0].price !== undefined && picked[0].old_price !== undefined) {
            price = picked[0].price;
            old_price = picked[0].old_price;
            cda = picked[0].cda;
        }

        let newDrops = {...this.state.drops};

        let reset = false;

        for (let index in newDrops) {
            if (reset) {
                newDrops[index] = -1;
            }
            if (index == key) {
                newDrops[index] = id;
                reset = true;
            }
        }

        this.setState({
            drops: newDrops,
            price: price,
            old_price: old_price,
            cda: cda,
            cashback_description: picked[0].cashback_description
        });
        if (picked[0].cda !== undefined) {
            this.updateUrl(picked[0].cda);
        }
    };

    handleMoreOptionsOnClick = () => {

        this.props.addPopup({
            type: Popups.RADIO_OPTIONS,
            onChange: (id, price, old_price, cda, cashback_description = "") => {
                this.setState({
                    selected_radio: id,
                    price: price,
                    old_price: old_price,
                    cda: cda,
                    cashback_description: cashback_description
                })
            },
            selected: this.state.selected_radio,
        })
    };

    getTags = () => {
        const data = this.props.benefit.tags;

        let res = [];

        for (let key in data) {
            res.push(<span key={key} className='tag'>{data[key]}</span>);
        }

        return res;
    };

    isCashBack() {
        const trade_charge_type = this.props.benefit.main.trade_charge_type;// from getDetailedBenefitByIdForWeb
        const tradeBenefitsChargeTypes = this.props.TradeBenefitsChargeTypes;// from generalDeclaration

        return tradeBenefitsChargeTypes[trade_charge_type] === "cashback"

    }

    render() {
        const benefit = this.props.benefit;
        const text = this.props.text;

        if (benefit === 'error') {
            return <Redirect to={routes.home}/>
        }

        const isDesktopOrLaptop = this.props.deviceState === 'desktop' || this.props.deviceState === 'desktop-large';
        let is_favorite = false;
        let showTags = false;
        let isActive = true;
        let display_cash_logged_users_only = false;
        let disc = '';


        if (benefit) {
            if (parseInt(benefit.main.benefit_type) !== 1000) {
                return <Redirect to={routes.home}/>;
            }

            display_cash_logged_users_only = benefit.main['display_price_members_only'] && !this.props.userData;

            isActive = benefit.main.active;

            if (this.props.userData) {
                is_favorite = this.props.userData.favoritesArr.indexOf(this.props.match.params.id) !== -1;
            }

            showTags = Object.keys(benefit.tags).length > 0;

            //checking if not logged user can see this benefit
            if (this.props.closedBenefitTypes.includes(parseInt(benefit.main.type))) {
                this.props.history.push(routes.home);
                this.props.addPopup({
                        type: Popups.LOGIN,
                    }
                )
            }

            disc = this.state.old_price - this.state.price;

            disc = disc % 1 === 0 ? disc : disc.toFixed(1);

            disc = formatNumber(disc);

        }


        let slider_data_sub_cat = {benefits: []};
        let slider_data_relative_brand = {benefits: []};
        //for bottom slider
        if (benefit.hasOwnProperty('relatedBenefitsBySubCat')) {
            slider_data_sub_cat = {
                benefits: benefit['relatedBenefitsBySubCat'].benefits,
                title: benefit['relatedBenefitsBySubCat'].title,
                btnText: benefit['relatedBenefitsBySubCat'].btnText
            };
        }

        if (benefit.hasOwnProperty('relatedBenefitsByBrand')) {
            slider_data_relative_brand = {
                benefits: benefit['relatedBenefitsByBrand'].benefits,
                title: benefit['relatedBenefitsByBrand'].title,
                btnText: benefit['relatedBenefitsByBrand'].btnText
            };
        }


        return (
            <section className='commercePage'>
                {benefit &&
                    <Fragment>
                        <BreadCrumbs className='bread-benefit' root={{text: 'דף הבית', route: routes.home}}
                                     crumbs={this.getBreadCrumbs()}/>
                        {this.state.preview_link && <div className='preview-link-indicator'>תצוגה מקדימה</div>}
                        <div className='top-banner'>
                            <div className={'gallery-wrapper ' + (benefit.main.images.length > 1 ? 'with-slider' : '')}>
                                <ImageCarousel
                                    className={'gallery-slider'}
                                    imgs={this.getSliderImages()}
                                    overlay={(
                                        <FavoriteButton
                                            data={{
                                                ...benefit,
                                                selectedOption: this.state.selected_radio,
                                            }}
                                            state={is_favorite}
                                        />
                                    )}
                                />
                                {benefit.main.dateExpired && (
                                    <div className={'count-down ' + (this.state.big_screen_type === 'embedded' ? 'video' : '')}>
                                        <div
                                            className={'timer-wrapper' + (benefit.main.dateExpired === '' ? ' hide-mobile' : '')}>
                                            {benefit.main.dateExpired !== '' &&
                                                <Timer className='benefit-timer' timeSpan={benefit.main.dateExpired}/>
                                            }
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className='discount-wrapper'>
                                <div className='head-title'>
                                    <h1 className='head-span'>{benefit.main.benefit_name}</h1>
                                    <h2 className='description'>
                                        {ReactHtmlParser(benefit.main.description, reactParserCommonOptions())}
                                    </h2>
                                </div>

                                {(benefit.show_badge || benefit.showFreeDelivery) && (
                                    <div className='terms'>
                                        {benefit.show_badge &&
                                            <div className='term-wrapper warranty'>
                                                <img src={getMediaPath(warranty)} alt='/'/>
                                                <span>{text['commerce_page_warranty']}</span>
                                            </div>
                                        }
                                        {benefit.showFreeDelivery && <div className='term-wrapper'>
                                            <img src={getMediaPath(truck)} alt='/'/>
                                            <span>{text['commerce_page_shipping']}</span>
                                        </div>
                                        }
                                    </div>
                                )}

                                {isDesktopOrLaptop && this.getSelectionSystem()}

                                {!display_cash_logged_users_only &&
                                    <div className='prices'>
                                        {this.state.old_price !== null &&this.state.old_price !== '0' && parseInt(this.state.old_price)>parseInt(this.state.price)&&
                                            <span className='data-span line-through'>{formatNumber(this.state.old_price)}</span>}
                                        {this.state.price &&
                                            <span className='price-span'>{formatNumber(this.state.price)}</span>}
                                        { parseInt(disc)>0&&<div className='disc-wrap'>
                                            <img src={getMediaPath(fire)} alt=''/>
                                            {this.state.price && <span
                                                className='disc-span'>{text['commerce_page_saving'] + ' ' + disc}</span>}
                                        </div>}
                                        {this.isCashBack() &&
                                            <div className="cash-back-wrapper">
                                                <p className="cash-back-text">{this.state.cashback_description}</p>
                                            </div>

                                        }
                                        {!isDesktopOrLaptop && isActive && this.getButton()}
                                    </div>
                                }

                                {display_cash_logged_users_only &&
                                    <img className='lock-image' src={getMediaPath(benefitsLock)} alt=''/>}

                                {!isDesktopOrLaptop && this.getSelectionSystem()}

                                {isDesktopOrLaptop && isActive && this.getButton()}
                            </div>
                        </div>

                        <div className='details-desktop'>
                            {this.getExtraData()}
                        </div>

                        {showTags &&
                            <div className='tags'>
                                <span className='tags-label'>{this.props.text['commerce_page_tags_label']}</span>
                                <div className='tags-container'>
                                    {this.getTags()}
                                </div>
                            </div>
                        }

                        <div className='extras'>
                            {slider_data_sub_cat.benefits.length > 0 &&
                                <div className='extra-container'>
                                    <BenefitsSlider data={slider_data_sub_cat}
                                                    className={'benefitsSlider'}
                                                    title={'מוצרים מהקטגוריה'}
                                    />
                                </div>
                            }
                            {slider_data_relative_brand.benefits.length > 0 &&
                                <div className='extra-container'>
                                    <BenefitsSlider data={slider_data_relative_brand}
                                                    className={'benefitsSlider'}
                                                    title={'מוצרים מהקטגוריה'}
                                    />
                                </div>
                            }

                        </div>

                        {!isActive &&
                            <div className='expired-layer'>
                                <h2>{text['benefit_page_expired_msg']}</h2>
                            </div>
                        }
                    </Fragment>
                }
                {!benefit &&
                    <Loader/>
                }
            </section>
        )
    }
}


function SliderArrow(props) {
    const {onClick, customClass} = props;
    return (
        <div className={customClass} onClick={onClick}>
            <img src={getMediaPath(arrow_gallery)} alt=""/>
        </div>
    );
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        benefitTypes: cleanUpObject(store.config.IconTypes),
        benefit: store.data.BenefitPage,
        text: store.config.Translations,
        closedBenefitTypes: store.config.ClosedBenefitTypes,
        userData: store.config.UserData,
        cart: store.config.Cart,
        TradeBenefitsChargeTypes: store.config.TradeBenefitsChargeTypes,
        telecardUrl: store.data.TelecardUrl,

    }
};

const mapDispatchToProps = dispatch => {
    return {
        getBenefitById: (payload) => dispatch(getBenefitById(payload)),
        setBenefitPage: (payload) => dispatch(setBenefitPage(payload)),
        addPopup: (payload) => dispatch(addPopup(payload)),
        removePopup: (payload) => dispatch(removePopup(payload)),
        addItem: (payload) => dispatch(addItem(payload)),
        addToken: (payload) => dispatch(addToken(payload)),
    }
};


export default connect(mapStateToProps, mapDispatchToProps, null, {pure: false})(CommercePage);
